// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import "./AdmDashBoardFee.css";
// import Select from "react-select";
// import Container from "react-bootstrap/Container";

// const FeeDashboard = () => {
//   const days = [
//     "Sunday",
//     "Monday",
//     "Tuesday",
//     "Wednesday",
//     "Thursday",
//     "Friday",
//     "Saturday",
//   ];

//   const [periodOptions, setPeriodOptions] = useState([]);
  

//  useEffect(() => {
//    fetch(`${ApiUrl.apiurl}Periods/GetAllPeriods/`)
//      .then((res) => res.json())
//      .then((data) => {
//        if (data?.data) {
//          const options = data.data.map((period) => ({
//            label: period.period_name,
//            value: period.period_name,
//          }));
//          setPeriodOptions(options);
//        }
//      })
//      .catch((error) => {
//        console.error("Error fetching periods:", error);
//      });
//  }, []);


//   // State to manage the selected month
//   const [selectedMonth, setSelectedMonth] = useState(getCurrentMonth());
//   const [feeData, setFeeData] = useState([]);

//   // Function to get the current month in "Month-Year" format
//   function getCurrentMonth() {
//     const date = new Date();
//     const monthName = date.toLocaleString("default", { month: "long" });
//     const year = date.getFullYear();
//     return `${monthName}-${year}`;
//   }

//   // Function to get month options for the year 2024
//   const getMonthOptions = () => {
//     const options = [];
//     const year = 2024;
//     for (let i = 0; i < 12; i++) {
//       const date = new Date(year, i, 1);
//       const monthName = date.toLocaleString("default", { month: "long" });
//       options.push(
//         <option key={i} value={`${monthName}-${year}`}>
//           {`${monthName}-${year}`}
//         </option>
//       );
//     }
//     return options;
//   };


//    const handleMonthChange = (option) => {
//      setSelectedMonth(option.value);
//    };
//   // Function to get the number of days in the selected month
//   const getDaysInMonth = (monthYear) => {
//     const [monthName, year] = monthYear.split("-");
//     const month = new Date(Date.parse(monthName + " 1, " + year)).getMonth();
//     const daysInMonth = new Date(year, month + 1, 0).getDate();
//     return daysInMonth;
//   };

//   // Function to get the first day of the month
//   const getFirstDayOfMonth = (monthYear) => {
//     const [monthName, year] = monthYear.split("-");
//     const month = new Date(Date.parse(monthName + " 1, " + year)).getMonth();
//     const firstDay = new Date(year, month, 1).getDay();
//     return firstDay;
//   };

//   // Function to generate table days based on the selected month
//   const generateCalendarData = () => {
//     const daysInMonth = getDaysInMonth(selectedMonth);
//     const firstDay = getFirstDayOfMonth(selectedMonth);
//     const calendarData = [];
//     let day = 1;

//     // Initialize calendar with empty strings
//     for (let week = 0; week < 6; week++) {
//       const weekData = [];
//       for (let dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
//         if (week === 0 && dayOfWeek < firstDay) {
//           weekData.push(""); // Empty cell for days before the first of the month
//         } else if (day <= daysInMonth) {
//           const dateString = `${day}-${selectedMonth.split("-")[1]}`;
//           const feeInfo = feeData.find((data) => data.date === dateString);
//           weekData.push({ day, feeReceived: feeInfo ? feeInfo.feeReceived : null });
//           day++;
//         } else {
//           weekData.push(""); // Empty cell for days after the end of the month
//         }
//       }
//       // Only add weeks if they have at least one day in the month
//       if (weekData.some((day) => day !== "")) {
//         calendarData.push(weekData);
//       }
//     }

//     return calendarData;
//   };

//   // const handleMonthChange = (event) => {
//   //   setSelectedMonth(event.target.value);
//   // };

//   // Example fee data: Only one fee deposit date per month
//   useEffect(() => {
//     const exampleFeeData = [
//       { date: "1-2024", feeReceived: 100 },
     
//       // Add more fee data for other months if needed
//     ];
//     setFeeData(exampleFeeData);
//   }, []);

//   return (
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-12">
//           <div className="card p-0">
//             <div className="card-body">
//               <p
//                 style={{
//                   marginBottom: "0px",
//                   textAlign: "center",
//                   fontSize: "20px",
//                   fontWeight: "700",
//                 }}
//               >
//                 FEE DASHBOARD
//               </p>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginTop: "1rem",
//                   marginBottom: "1rem",
//                   gap: "10px", // Space between label and dropdown
//                 }}
//               >
//                 <label htmlFor="month" style={{ margin: 0 }}>
//                   Month
//                 </label>

//                 <Select
//                   id="month"
//                   name="month"
//                   className="detail"
//                   value={
//                     periodOptions.find((opt) => opt.value === selectedMonth) ||
//                     null
//                   }
//                   onChange={handleMonthChange}
//                   options={periodOptions}
//                   classNamePrefix="react-select"
//                   isSearchable={false}
//                   styles={{
//                     container: (provided) => ({
//                       ...provided,
//                       width: "140px",
//                     }),
//                   }}
//                 />
//               </div>

//               <div className="col-12">
//                 <div className="table-responsive">
//                   <table
//                     // className="calendar"
//                     // style={{ width: "100%", tableLayout: "fixed" }}
//                     className="table"
//                   >
//                     <thead>
//                       <tr>
//                         {days.map((day) => (
//                           <th key={day}>{day}</th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {generateCalendarData().map((week, weekIndex) => (
//                         <tr key={weekIndex}>
//                           {week.map((day, dayIndex) => (
//                             <td key={dayIndex} style={{ textAlign: "center" }}>
//                               {day && day.day}
//                               {day && day.feeReceived && (
//                                 <Link to="/paymentdetails">
//                                   <div
//                                     style={{
//                                       fontSize: "0.8em",
//                                       color: "green",
//                                     }}
//                                   >
//                                     Fee: {day.feeReceived}
//                                   </div>
//                                 </Link>
//                               )}
//                             </td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               <div className="details-admin mx-1 ">
//                 <div
//                   className="period-fee-details custom-section-box"
//                   style={{ backgroundColor: "white", fontSize: "14px" }}
//                 >
//                   <h3>Period Fee Details</h3>
//                   <p className="paragraph-dashboard">
//                     Fee till Period:{" "}
//                     <span>
//                       {selectedMonth.split("-")[0].toUpperCase().slice(0, 3)}
//                       {selectedMonth.split("-")[1].slice(-2)}
//                     </span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Dues till {selectedMonth}: <span>0.00</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Discount till {selectedMonth}: <span>0.00</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Collectable till {selectedMonth}: <span>0.00</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Collected till {selectedMonth}: <span>0.00</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Due till {selectedMonth}: <span>0.00</span>
//                   </p>
//                 </div>

//                 <div
//                   className="session-fee-details  custom-section-box "
//                   style={{ backgroundColor: "white" }}
//                 >
//                   <h3>Session Fee Details</h3>
//                   <p className="paragraph-dashboard">
//                     Session:{" "}
//                     <span>{`${selectedMonth.split("-")[1]}-${
//                       parseInt(selectedMonth.split("-")[1], 10) + 1
//                     }`}</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Dues: <span>0.00</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Discount: <span>0.00</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Collectable: <span>0.00</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Collected: <span>0.00</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Balance: <span>0.00</span>
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FeeDashboard;



// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import "./AdmDashBoardFee.css";
// import Select from "react-select";
// import Container from "react-bootstrap/Container";

// const FeeDashboard = () => {
//   const days = [
//     "Sunday",
//     "Monday",
//     "Tuesday",
//     "Wednesday",
//     "Thursday",
//     "Friday",
//     "Saturday",
//   ];
//   const [sessionFeeDetails, setSessionFeeDetails] = useState({});

//   const [periodOptions, setPeriodOptions] = useState([]);
//   const [selectedPeriod, setSelectedPeriod] = useState(null);
//   // State to manage the selected month
//   const [selectedMonth, setSelectedMonth] = useState(getCurrentMonth());
//   const [feeData, setFeeData] = useState([]);

//   useEffect(() => {
//     fetch(`${ApiUrl.apiurl}Periods/GetAllPeriods/`)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data?.data) {
//           const options = data.data.map((period) => ({
//             label: period.period_name,
//             value: period.period_name,
//             start_date: period.start_date,
//             end_date: period.end_date,
//           }));
//           setPeriodOptions(options);

//           // Optionally set default selected period
//           if (options.length > 0) {
//             setSelectedPeriod(options[0]); // new state
//           }
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching periods:", error);
//       });
//   }, []);

//   useEffect(() => {
//     if (selectedPeriod) {
//       const { start_date, end_date } = selectedPeriod;
//       const academic_year_id = localStorage.getItem("academicSessionId");
//       const org_id = localStorage.getItem("orgId");
//       const branch_id = localStorage.getItem("branchId");

//       const url1 = `${ApiUrl.apiurl}FeesDashBoard/dashboard/?academic_year_id=${academic_year_id}&org_id=${org_id}&branch_id=${branch_id}&from_date=${start_date}&to_date=${end_date}`;

//       fetch(url1)
//         .then((res) => res.json())
//         .then((data) => {
//           if (data?.data) {
//             setFeeData(data.data);
//           } else {
//             setFeeData([]);
//           }
//         })
//         .catch((error) => console.error("Error fetching fee data:", error));

//       const url2 = `${ApiUrl.apiurl}FeesDashBoard/feescalculateBasedOnAcademic/?academic_year_id=${academic_year_id}&org_id=${org_id}&branch_id=${branch_id}`;

//       fetch(url2)
//         .then((res) => res.json())
//         .then((data) => {
//           if (data?.data) {
//             setSessionFeeDetails(data.data);
//           } else {
//             setSessionFeeDetails({});
//           }
//         })
//         .catch((error) =>
//           console.error("Error fetching session fee details:", error)
//         );
//     }
//   }, [selectedPeriod]);

//   // Function to get the current month in "Month-Year" format
//   function getCurrentMonth() {
//     const date = new Date();
//     const monthName = date.toLocaleString("default", { month: "long" });
//     const year = date.getFullYear();
//     return `${monthName}-${year}`;
//   }

//   // Function to get month options for the year 2024
//   const getMonthOptions = () => {
//     const options = [];
//     const year = 2024;
//     for (let i = 0; i < 12; i++) {
//       const date = new Date(year, i, 1);
//       const monthName = date.toLocaleString("default", { month: "long" });
//       options.push(
//         <option key={i} value={`${monthName}-${year}`}>
//           {`${monthName}-${year}`}
//         </option>
//       );
//     }
//     return options;
//   };

//   const handleMonthChange = (option) => {
//     setSelectedMonth(option.value);
//   };
//   // Function to get the number of days in the selected month
//   const getDaysInMonth = (monthYear) => {
//     const [monthName, year] = monthYear.split("-");
//     const month = new Date(Date.parse(monthName + " 1, " + year)).getMonth();
//     const daysInMonth = new Date(year, month + 1, 0).getDate();
//     return daysInMonth;
//   };

//   // Function to get the first day of the month
//   const getFirstDayOfMonth = (monthYear) => {
//     const [monthName, year] = monthYear.split("-");
//     const month = new Date(Date.parse(monthName + " 1, " + year)).getMonth();
//     const firstDay = new Date(year, month, 1).getDay();
//     return firstDay;
//   };

//   // Function to generate table days based on the selected month
//  const generateCalendarData = () => {
//    const [monthStr, year] = selectedMonth.split("-");
//    const monthIndex = new Date(Date.parse(`${monthStr} 1, 2000`)).getMonth(); // Month index (0-11)
//    const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
//    const firstDay = new Date(year, monthIndex, 1).getDay();

//    const calendarData = [];
//    let day = 1;

//    // Initialize calendar with empty strings
//    for (let week = 0; week < 6; week++) {
//      const weekData = [];
//      for (let dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
//        if (week === 0 && dayOfWeek < firstDay) {
//          weekData.push(""); // Empty cell for days before the first of the month
//        } else if (day <= daysInMonth) {
//          // Format the date as YYYY-MM-DD
//          const paddedMonth = String(monthIndex + 1).padStart(2, "0");
//          const paddedDay = String(day).padStart(2, "0");
//          const formattedDate = `${year}-${paddedMonth}-${paddedDay}`;

//          const feeInfo = feeData.find((data) => data.date === formattedDate);
//          weekData.push({
//            day,
//            feeReceived: feeInfo ? feeInfo.feeReceived : null,
//          });
//          day++;
//        } else {
//          weekData.push(""); // Empty cell after end of month
//        }
//      }

//      if (weekData.some((day) => day !== "")) {
//        calendarData.push(weekData);
//      }
//    }

//    return calendarData;
//  };


//   // const handleMonthChange = (event) => {
//   //   setSelectedMonth(event.target.value);
//   // };

//   // Example fee data: Only one fee deposit date per month
//   // useEffect(() => {
//   //   const exampleFeeData = [
//   //     { date: "1-2024", feeReceived: 100 },

//   //     // Add more fee data for other months if needed
//   //   ];
//   //   setFeeData(exampleFeeData);
//   // }, []);

//   return (
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-12">
//           <div className="card p-0">
//             <div className="card-body">
//               <p
//                 style={{
//                   marginBottom: "0px",
//                   textAlign: "center",
//                   fontSize: "20px",
//                   fontWeight: "700",
//                 }}
//               >
//                 FEE DASHBOARD
//               </p>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginTop: "1rem",
//                   marginBottom: "1rem",
//                   gap: "10px", // Space between label and dropdown
//                 }}
//               >
//                 <label htmlFor="month" style={{ margin: 0 }}>
//                   Month
//                 </label>

//                 <Select
//                   id="month"
//                   name="month"
//                   className="detail"
//                   value={
//                     periodOptions.find((opt) => opt.value === selectedMonth) ||
//                     null
//                   }
//                   onChange={handleMonthChange}
//                   options={periodOptions}
//                   classNamePrefix="react-select"
//                   isSearchable={false}
//                   styles={{
//                     container: (provided) => ({
//                       ...provided,
//                       width: "140px",
//                     }),
//                   }}
//                 />
//               </div>

//               <div className="col-12">
//                 <div className="table-responsive">
//                   <table className="table">
//                     <thead>
//                       <tr>
//                         {days.map((day) => (
//                           <th key={day}>{day}</th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {generateCalendarData().map((week, weekIndex) => (
//                         <tr key={weekIndex}>
//                           {week.map((day, dayIndex) => (
//                             <td key={dayIndex} style={{ textAlign: "center" }}>
//                               {day && day.day}
//                               {day && day.feeReceived && (
//                                 <Link to="/paymentdetails">
//                                   <div
//                                     style={{
//                                       fontSize: "0.8em",
//                                       color: "green",
//                                     }}
//                                   >
//                                     Fee: {day.feeReceived}
//                                   </div>
//                                 </Link>
//                               )}
//                             </td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               <div className="details-admin mx-1">
//                 <div
//                   className="session-fee-details custom-section-box"
//                   style={{ backgroundColor: "white" }}
//                 >
//                   <h3>Session Fee Details</h3>
//                   <p className="paragraph-dashboard">
//                     Session:{" "}
//                     <span>{`${selectedMonth.split("-")[1]}-${
//                       parseInt(selectedMonth.split("-")[1], 10) + 1
//                     }`}</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Dues:{" "}
//                     <span>{sessionFeeDetails.totalDues || "0.00"}</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Discount:{" "}
//                     <span>{sessionFeeDetails.totalDiscount || "0.00"}</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Collectable:{" "}
//                     <span>{sessionFeeDetails.totalCollectable || "0.00"}</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Collected:{" "}
//                     <span>{sessionFeeDetails.totalCollected || "0.00"}</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Balance:{" "}
//                     <span>{sessionFeeDetails.totalBalance || "0.00"}</span>
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FeeDashboard;

// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import "./AdmDashBoardFee.css";
// import Select from "react-select";
// import { ApiUrl } from "../../../ApiUrl";

// const FeeDashboard = () => {
//   const days = [
//     "Sunday",
//     "Monday",
//     "Tuesday",
//     "Wednesday",
//     "Thursday",
//     "Friday",
//     "Saturday",
//   ];
//   const [sessionFeeDetails, setSessionFeeDetails] = useState({});
//   const [periodOptions, setPeriodOptions] = useState([]);
//   const [selectedPeriod, setSelectedPeriod] = useState(null);
//   const [selectedMonth, setSelectedMonth] = useState(getCurrentMonth());
//   const [feeData, setFeeData] = useState([]);

//   // useEffect(() => {
//   //   fetch(`${ApiUrl.apiurl}Periods/GetAllPeriods/`)
//   //     .then((res) => res.json())
//   //     .then((data) => {
//   //       if (data?.data) {
//   //         const options = data.data.map((period) => ({
//   //           label: period.period_name,
//   //           value: period.period_name,
//   //           start_date: period.period_start_date, // No format here
//   //           end_date: period.period_end_date, // No format here
//   //         }));
//   //         setPeriodOptions(options);
//   //         if (options.length > 0) setSelectedPeriod(options[0]);
//   //       }
//   //     })
//   //     .catch((error) => console.error("Error fetching periods:", error));
//   // }, []);

//   // useEffect(() => {
//   //   if (selectedPeriod) {
//   //     const { start_date, end_date } = selectedPeriod;
//   //     const academic_year_id = localStorage.getItem("academicSessionId");
//   //     const org_id = localStorage.getItem("orgId");
//   //     const branch_id = localStorage.getItem("branchId");

//   //     const url1 = `${ApiUrl.apiurl}FeesDashBoard/dashboard/?academic_year_id=${academic_year_id}&org_id=${org_id}&branch_id=${branch_id}&from_date=${start_date}&to_date=${end_date}`;

//   //     fetch(url1)
//   //       .then((res) => res.json())
//   //       .then((data) => {
//   //         if (data?.data) setFeeData(data.data);
//   //         else setFeeData([]);
//   //       })
//   //       .catch((error) => console.error("Error fetching fee data:", error));

//   //     const url2 = `${ApiUrl.apiurl}FeesDashBoard/feescalculateBasedOnAcademic/?academic_year_id=${academic_year_id}&org_id=${org_id}&branch_id=${branch_id}`;

//   //     fetch(url2)
//   //       .then((res) => res.json())
//   //       .then((data) => {
//   //         if (data?.data) setSessionFeeDetails(data.data);
//   //         else setSessionFeeDetails({});
//   //       })
//   //       .catch((error) =>
//   //         console.error("Error fetching session fee details:", error)
//   //       );
//   //   }
//   // }, [selectedPeriod]);

//   useEffect(() => {
//     fetch(`${ApiUrl.apiurl}Periods/GetAllPeriods/`)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data?.data) {
//           const options = data.data.map((period) => {
//             const label = period.period_name;
//             const value = period.period_name;
//             return {
//               label,
//               value,
//               start_date: period.period_start_date,
//               end_date: period.period_end_date,
//             };
//           });

//           setPeriodOptions(options);

//           // Try to select the current month
//           const currentMonthLabel = getCurrentMonth();
//           const currentOption = options.find(
//             (opt) => opt.value === currentMonthLabel
//           );

//           if (currentOption) {
//             setSelectedPeriod(currentOption);
//             setSelectedMonth(currentOption.value);
//           } else {
//             setSelectedPeriod(options[0]);
//             setSelectedMonth(options[0]?.value);
//           }
//         }
//       })
//       .catch((error) => console.error("Error fetching periods:", error));
//   }, []);

//   useEffect(() => {
//     if (selectedPeriod) {
//       const { start_date, end_date } = selectedPeriod;
//       const academic_year_id = localStorage.getItem("academicSessionId");
//       const org_id = localStorage.getItem("orgId");
//       const branch_id = localStorage.getItem("branchId");

//       const url1 = `${ApiUrl.apiurl}FeesDashBoard/dashboard/?academic_year_id=${academic_year_id}&org_id=${org_id}&branch_id=${branch_id}&from_date=${start_date}&to_date=${end_date}`;

//       fetch(url1)
//         .then((res) => res.json())
//         .then((data) => {
//           if (data?.data) setFeeData(data.data);
//           else setFeeData([]);
//         })
//         .catch((error) => console.error("Error fetching fee data:", error));

//       const url2 = `${ApiUrl.apiurl}FeesDashBoard/feescalculateBasedOnAcademic/?academic_year_id=${academic_year_id}&org_id=${org_id}&branch_id=${branch_id}`;

//       fetch(url2)
//         .then((res) => res.json())
//         .then((data) => {
//           if (data?.data) {
//             const sessionData = data.data;
//             const totalCollectable =
//               sessionData.element_amount - sessionData.total_discount_amount;
//             const totalBalance =
//               totalCollectable - sessionData.total_paid_amount;

//             setSessionFeeDetails({
//               totalDues: sessionData.element_amount,
//               totalDiscount: sessionData.total_discount_amount,
//               totalCollectable: totalCollectable,
//               totalCollected: sessionData.total_paid_amount,
//               totalBalance: totalBalance,
//               session: sessionData.sesion,
//             });
//           } else {
//             setSessionFeeDetails({});
//           }
//         })
//         .catch((error) =>
//           console.error("Error fetching session fee details:", error)
//         );
//     }
//   }, [selectedPeriod]);

//   function getCurrentMonth() {
//     const date = new Date();
//     const monthName = date.toLocaleString("default", { month: "long" });
//     const year = date.getFullYear();
//     return `${monthName}-${year}`;
//   }

//   // Before generateCalendarData
//   const currentYear = selectedPeriod
//     ? new Date(selectedPeriod.start_date).getFullYear()
//     : new Date().getFullYear();
//   const currentMonth = selectedPeriod
//     ? new Date(selectedPeriod.start_date).getMonth()
//     : new Date().getMonth();

//   // Your generateCalendarData() follows after this

//   // const generateCalendarData = () => {
//   //   const startDate = new Date(currentYear, currentMonth, 1);
//   //   const endDate = new Date(currentYear, currentMonth + 1, 0);
//   //   const daysInMonth = endDate.getDate();

//   //   const calendar = [];
//   //   let week = [];

//   //   for (let i = 1; i <= daysInMonth; i++) {
//   //     const date = new Date(currentYear, currentMonth, i);
//   //     const dayOfWeek = date.getDay(); // 0 (Sun) to 6 (Sat)

//   //     if (i === 1 && dayOfWeek !== 0) {
//   //       for (let j = 0; j < dayOfWeek; j++) {
//   //         week.push(null); // Empty cells before first day
//   //       }
//   //     }

//   //     const formattedDate = date.toLocaleDateString("en-CA"); // Gives 'YYYY-MM-DD' in local time
//   //     // 'YYYY-MM-DD'

//   //     const feeEntry = feeData.find(
//   //       (entry) => entry.receipt_date === formattedDate
//   //     );

//   //     week.push({
//   //       day: i,
//   //       feeReceived: feeEntry ? feeEntry.received_amount : null,
//   //     });

//   //     if (dayOfWeek === 6 || i === daysInMonth) {
//   //       calendar.push(week);
//   //       week = [];
//   //     }
//   //   }

//   //   return calendar;
//   // };

//   const generateCalendarData = () => {
//     if (!selectedPeriod?.start_date || !selectedPeriod?.end_date) return [];

//     const calendarData = [];
//     const start = new Date(selectedPeriod.start_date);
//     const end = new Date(selectedPeriod.end_date);

//     // Convert feeData to a map for fast lookup
//     const feeMap = {};
//     feeData.forEach((item) => {
//       const key = new Date(item.receipt_date).toLocaleDateString("en-CA"); // Ensure same format
//       feeMap[key] = item.received_amount;
//     });

//     let currentDate = new Date(start);
//     currentDate.setHours(0, 0, 0, 0); // Normalize time

//     // Start from the Sunday of the first week
//     const firstDayOfWeek = currentDate.getDay();
//     currentDate.setDate(currentDate.getDate() - firstDayOfWeek);

//     while (currentDate <= end || currentDate.getDay() !== 0) {
//       const week = [];

//       for (let i = 0; i < 7; i++) {
//         const dateCopy = new Date(currentDate);
//         const dateStr = dateCopy.toLocaleDateString("en-CA"); // Local YYYY-MM-DD

//         if (
//           dateCopy < new Date(selectedPeriod.start_date) ||
//           dateCopy > new Date(selectedPeriod.end_date)
//         ) {
//           week.push(null);
//         } else {
//           week.push({
//             day: dateCopy.getDate(),
//             date: dateStr,
//             feeReceived: feeMap[dateStr] || null,
//           });
//         }

//         currentDate.setDate(currentDate.getDate() + 1);
//       }

//       calendarData.push(week);
//     }

//     return calendarData;
//   };

//   return (
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-12">
//           <div className="card p-0">
//             <div className="card-body">
//               <p
//                 style={{
//                   marginBottom: "0px",
//                   textAlign: "center",
//                   fontSize: "20px",
//                   fontWeight: "700",
//                 }}
//               >
//                 FEE DASHBOARD
//               </p>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginTop: "1rem",
//                   marginBottom: "1rem",
//                   gap: "10px",
//                 }}
//               >
//                 <label htmlFor="month" style={{ margin: 0 }}>
//                   Month
//                 </label>
//                 <Select
//                   id="month"
//                   name="month"
//                   className="detail"
//                   value={
//                     periodOptions.find((opt) => opt.value === selectedMonth) ||
//                     null
//                   }
//                   onChange={(selected) => {
//                     setSelectedPeriod(selected);
//                     setSelectedMonth(selected.value);
//                   }}
//                   options={periodOptions}
//                   classNamePrefix="react-select"
//                   isSearchable={false}
//                   styles={{
//                     container: (provided) => ({ ...provided, width: "200px" }),
//                   }}
//                 />
//               </div>

//               {/* <div className="col-12">
//                 <div className="table-responsive">
//                   <table className="table">
//                     <thead>
//                       <tr>
//                         {days.map((day) => (
//                           <th key={day}>{day}</th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {generateCalendarData().map((week, weekIndex) => (
//                         <tr key={weekIndex}>
//                           {week.map((day, dayIndex) => (
//                             <td key={dayIndex} style={{ textAlign: "center" }}>
//                               {day && day.day}
//                               {day && day.feeReceived !== null && (
//                                 <Link to="/paymentdetails">
//                                   <div
//                                     style={{
//                                       fontSize: "0.8em",
//                                       color: "green",
//                                     }}
//                                   >
//                                     Fee: {day.feeReceived}
//                                   </div>
//                                 </Link>
//                               )}
//                             </td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div> */}

//               <div className="col-12">
//                 <div className="table-responsive">
//                   <table className="table">
//                     <thead>
//                       <tr>
//                         {days.map((day) => (
//                           <th key={day}>{day}</th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {generateCalendarData().map((week, weekIndex) => (
//                         <tr key={weekIndex}>
//                           {week.map((day, dayIndex) => (
//                             <td key={dayIndex} style={{ textAlign: "center" }}>
//                               {day && day.day}
//                               {day && day.feeReceived !== null && (
//                                 <Link
//                                   to="/paymentdetails"
//                                   state={{ selectedDate: day.date }}
//                                 >
//                                   <div
//                                     style={{
//                                       fontSize: "0.8em",
//                                       color: "green",
//                                       cursor: "pointer",
//                                     }}
//                                   >
//                                     Fee: {day.feeReceived}
//                                   </div>
//                                 </Link>
//                               )}
//                             </td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               <div className="details-admin mx-1">
//                 <div
//                   className="session-fee-details custom-section-box"
//                   style={{ backgroundColor: "white" }}
//                 >
//                   <h3>Session Fee Details</h3>
//                   <p className="paragraph-dashboard">
//                     Session: <span>{sessionFeeDetails.session || "N/A"}</span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Dues:{" "}
//                     <span>
//                       {sessionFeeDetails.totalDues?.toFixed(2) || "0.00"}
//                     </span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Discount:{" "}
//                     <span>
//                       {sessionFeeDetails.totalDiscount?.toFixed(2) || "0.00"}
//                     </span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Collectable:{" "}
//                     <span>
//                       {sessionFeeDetails.totalCollectable?.toFixed(2) || "0.00"}
//                     </span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Collected:{" "}
//                     <span>
//                       {sessionFeeDetails.totalCollected?.toFixed(2) || "0.00"}
//                     </span>
//                   </p>
//                   <p className="paragraph-dashboard">
//                     Total Balance:{" "}
//                     <span>
//                       {sessionFeeDetails.totalBalance?.toFixed(2) || "0.00"}
//                     </span>
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FeeDashboard;



import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./AdmDashBoardFee.css";
import Select from "react-select";
import { ApiUrl } from "../../../ApiUrl";

const FeeDashboard = () => {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const [sessionFeeDetails, setSessionFeeDetails] = useState({});
  const monthOptions = [
    { label: "January", value: 0 },
    { label: "February", value: 1 },
    { label: "March", value: 2 },
    { label: "April", value: 3 },
    { label: "May", value: 4 },
    { label: "June", value: 5 },
    { label: "July", value: 6 },
    { label: "August", value: 7 },
    { label: "September", value: 8 },
    { label: "October", value: 9 },
    { label: "November", value: 10 },
    { label: "December", value: 11 },
  ];
  const [academicSessionCode, setAcademicSessionCode] = useState("");
  const [yearOptions, setYearOptions] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [feeData, setFeeData] = useState([]);

  const formatDateKey = (dateObj) => {
    const y = dateObj.getFullYear();
    const m = String(dateObj.getMonth() + 1).padStart(2, "0");
    const d = String(dateObj.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  const normalizeApiDate = (dateValue) => {
    if (!dateValue) return "";

    const raw = String(dateValue);
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
    if (raw.includes("T")) return raw.split("T")[0];

    const parsed = new Date(raw);
    if (Number.isNaN(parsed.getTime())) return "";
    return formatDateKey(parsed);
  };

  const getAcademicYearsFromCode = (code) => {
    if (!code || typeof code !== "string") return [];
    const parts = code.split("-");
    if (parts.length !== 2) return [];

    const startYear = Number(parts[0]);
    let endYear = Number(parts[1]);

    if (Number.isNaN(startYear) || Number.isNaN(endYear)) return [];

    if (endYear < 100) {
      endYear = Math.floor(startYear / 100) * 100 + endYear;
    }

    if (endYear < startYear) {
      endYear = startYear;
    }

    const years = [];
    for (let y = startYear; y <= endYear; y++) {
      years.push(y);
    }
    return years;
  };
  const [academicContext, setAcademicContext] = useState(() => ({
    academic_year_id: localStorage.getItem("academicSessionId") || "",
    org_id: localStorage.getItem("orgId") || "",
    branch_id: localStorage.getItem("branchId") || "",
  }));

  const readAcademicContext = () => ({
    academic_year_id: localStorage.getItem("academicSessionId") || "",
    org_id: localStorage.getItem("orgId") || "",
    branch_id: localStorage.getItem("branchId") || "",
  });

  useEffect(() => {
    const syncAcademicContext = () => {
      setAcademicContext(readAcademicContext());
    };

    window.addEventListener("academicSessionChanged", syncAcademicContext);
    window.addEventListener("storage", syncAcademicContext);

    return () => {
      window.removeEventListener(
        "academicSessionChanged",
        syncAcademicContext
      );
      window.removeEventListener("storage", syncAcademicContext);
    };
  }, []);

  useEffect(() => {
    const sessionId = localStorage.getItem("academicSessionId");
    if (!sessionId) return;

    fetch(`${ApiUrl.apiurl}AcademicYear/GetAllAcademicYear/`)
      .then((res) => res.json())
      .then((data) => {
        const years = Array.isArray(data?.data) ? data.data : [];
        const selectedSession = years.find(
          (item) => String(item.id) === String(sessionId)
        );
        const code = selectedSession?.sesion_code || "";

        setAcademicSessionCode(code);

        const academicYears = getAcademicYearsFromCode(code);
        const yearSelectOptions = academicYears.map((year) => ({
          label: String(year),
          value: year,
        }));

        setYearOptions(yearSelectOptions);

        if (yearSelectOptions.length) {
          const currentYear = new Date().getFullYear();
          const found = yearSelectOptions.find((y) => y.value === currentYear);
          setSelectedYear((found || yearSelectOptions[0]).value);
        }
      })
      .catch((error) => console.error("Error fetching academic years:", error));
  }, [academicContext.academic_year_id]);

  useEffect(() => {
    const { academic_year_id, org_id, branch_id } = academicContext;

    if (!academic_year_id || !org_id || !branch_id) {
      setFeeData([]);
      setSessionFeeDetails({});
      return;
    }

    const fromDate = formatDateKey(new Date(selectedYear, selectedMonth, 1));
    const toDate = formatDateKey(new Date(selectedYear, selectedMonth + 1, 0));

    const url1 = `${ApiUrl.apiurl}FeesDashBoard/dashboard/?academic_year_id=${academic_year_id}&org_id=${org_id}&branch_id=${branch_id}&from_date=${fromDate}&to_date=${toDate}`;

    fetch(url1)
      .then((res) => res.json())
      .then((data) => {
        if (data?.data) setFeeData(data.data);
        else setFeeData([]);
      })
      .catch((error) => console.error("Error fetching fee data:", error));

    const url2 = `${ApiUrl.apiurl}FeesDashBoard/feescalculateBasedOnAcademic/?academic_year_id=${academic_year_id}&org_id=${org_id}&branch_id=${branch_id}`;

    fetch(url2)
      .then((res) => res.json())
      .then((data) => {
        if (data?.data) {
          const sessionData = data.data;
          const totalCollectable =
            Number(sessionData.element_amount || 0) -
            Number(sessionData.total_discount_amount || 0);
          const totalBalance =
            totalCollectable - Number(sessionData.total_paid_amount || 0);

          setSessionFeeDetails({
            totalDues: Number(sessionData.element_amount || 0),
            totalDiscount: Number(sessionData.total_discount_amount || 0),
            totalCollectable,
            totalCollected: Number(sessionData.total_paid_amount || 0),
            totalBalance,
            session: sessionData.sesion || academicSessionCode,
          });
        } else {
          setSessionFeeDetails({});
        }
      })
      .catch((error) =>
        console.error("Error fetching session fee details:", error)
      );
  }, [selectedMonth, selectedYear, academicContext, academicSessionCode]);

  // Your generateCalendarData() follows after this

  // const generateCalendarData = () => {
  //   const startDate = new Date(currentYear, currentMonth, 1);
  //   const endDate = new Date(currentYear, currentMonth + 1, 0);
  //   const daysInMonth = endDate.getDate();

  //   const calendar = [];
  //   let week = [];

  //   for (let i = 1; i <= daysInMonth; i++) {
  //     const date = new Date(currentYear, currentMonth, i);
  //     const dayOfWeek = date.getDay(); // 0 (Sun) to 6 (Sat)

  //     if (i === 1 && dayOfWeek !== 0) {
  //       for (let j = 0; j < dayOfWeek; j++) {
  //         week.push(null); // Empty cells before first day
  //       }
  //     }

  //     const formattedDate = date.toLocaleDateString("en-CA"); // Gives 'YYYY-MM-DD' in local time
  //     // 'YYYY-MM-DD'

  //     const feeEntry = feeData.find(
  //       (entry) => entry.receipt_date === formattedDate
  //     );

  //     week.push({
  //       day: i,
  //       feeReceived: feeEntry ? feeEntry.received_amount : null,
  //     });

  //     if (dayOfWeek === 6 || i === daysInMonth) {
  //       calendar.push(week);
  //       week = [];
  //     }
  //   }

  //   return calendar;
  // };

  const generateCalendarData = () => {
    const calendarData = [];
    const start = new Date(selectedYear, selectedMonth, 1);
    const end = new Date(selectedYear, selectedMonth + 1, 0);

    // Ensure time part is reset
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    // Convert feeData to a map for quick access
    const feeMap = {};
    feeData.forEach((item) => {
      const key = normalizeApiDate(item.receipt_date);
      const amount = Number(item.received_amount || 0);

      if (!key) return;
      feeMap[key] = (feeMap[key] || 0) + amount;
    });

    let currentDate = new Date(start);

    // Fill the first week with empty cells if month doesn't start on Sunday
    const firstWeek = [];
    const startDayOfWeek = currentDate.getDay(); // 0 (Sun) to 6 (Sat)

    for (let i = 0; i < startDayOfWeek; i++) {
      firstWeek.push(null);
    }

    // Start adding actual dates
    while (currentDate <= end) {
      const dateCopy = new Date(currentDate);
      const dateStr = formatDateKey(dateCopy);

      firstWeek.push({
        day: dateCopy.getDate(),
        date: dateStr,
        feeReceived: feeMap[dateStr] || null,
      });

      if (firstWeek.length === 7) {
        calendarData.push(firstWeek.slice());
        firstWeek.length = 0; // reset for next week
      }

      currentDate.setDate(currentDate.getDate() + 1);
    }

    // Push the last week if it's not complete
    if (firstWeek.length > 0) {
      // Fill remaining cells with null
      while (firstWeek.length < 7) {
        firstWeek.push(null);
      }
      calendarData.push(firstWeek);
    }

    return calendarData;
  };
  
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                FEE DASHBOARD
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "1rem",
                  marginBottom: "1rem",
                  gap: "10px",
                }}
              >
                <label htmlFor="month" style={{ margin: 0 }}>
                  Month
                </label>
                <Select
                  id="month"
                  name="month"
                  className="detail"
                  value={monthOptions.find((opt) => opt.value === selectedMonth)}
                  onChange={(selected) => {
                    setSelectedMonth(selected.value);
                  }}
                  options={monthOptions}
                  classNamePrefix="react-select"
                  isSearchable={false}
                  styles={{
                    container: (provided) => ({ ...provided, width: "200px" }),
                  }}
                />
                <label htmlFor="year" style={{ margin: 0 }}>
                  Year
                </label>
                <Select
                  id="year"
                  name="year"
                  className="detail"
                  value={yearOptions.find((opt) => opt.value === selectedYear) || null}
                  onChange={(selected) => {
                    setSelectedYear(selected.value);
                  }}
                  options={yearOptions}
                  classNamePrefix="react-select"
                  isSearchable={false}
                  styles={{
                    container: (provided) => ({ ...provided, width: "120px" }),
                  }}
                />
              </div>

              {/* <div className="col-12">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        {days.map((day) => (
                          <th key={day}>{day}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {generateCalendarData().map((week, weekIndex) => (
                        <tr key={weekIndex}>
                          {week.map((day, dayIndex) => (
                            <td key={dayIndex} style={{ textAlign: "center" }}>
                              {day && day.day}
                              {day && day.feeReceived !== null && (
                                <Link to="/paymentDetails">
                                  <div
                                    style={{
                                      fontSize: "0.8em",
                                      color: "green",
                                    }}
                                  >
                                    Fee: {day.feeReceived}
                                  </div>
                                </Link>
                              )}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div> */}

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        {days.map((day) => (
                          <th key={day}>{day}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {generateCalendarData().map((week, weekIndex) => (
                        <tr key={weekIndex}>
                          {week.map((day, dayIndex) => (
                            <td key={dayIndex} style={{ textAlign: "center" }}>
                              {day && day.day}
                              {day && day.feeReceived !== null && (
                                <Link
                                  to="/paymentDetails"
                                  state={{ selectedDate: day.date }}
                                >
                                  <div
                                    style={{
                                      fontSize: "0.8em",
                                      color: "green",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Fee: {Number(day.feeReceived || 0).toLocaleString("en-IN")}
                                  </div>
                                </Link>
                              )}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="details-admin mx-1">
                <div
                  className="session-fee-details custom-section-box"
                  style={{ backgroundColor: "white" }}
                >
                  <h3>Session Fee Details</h3>
                  <p className="paragraph-dashboard">
                    Session: <span>{sessionFeeDetails.session || "N/A"}</span>
                  </p>
                  <p className="paragraph-dashboard">
                    Total Dues:{" "}
                    <span>
                      {Number(sessionFeeDetails.totalDues || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </p>
                  <p className="paragraph-dashboard">
                    Total Discount:{" "}
                    <span>
                      {Number(sessionFeeDetails.totalDiscount || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </p>
                  <p className="paragraph-dashboard">
                    Total Collectable:{" "}
                    <span>
                      {Number(sessionFeeDetails.totalCollectable || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </p>
                  <p className="paragraph-dashboard">
                    Total Collected:{" "}
                    <span>
                      {Number(sessionFeeDetails.totalCollected || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </p>
                  <p className="paragraph-dashboard">
                    Total Balance:{" "}
                    <span>
                      {Number(sessionFeeDetails.totalBalance || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeeDashboard;
